/**
 * @generated SignedSource<<9132f573e0af7061f4920c2ac876bb61>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_groupResults$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_groupRow">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly firstGroup?: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow">;
  } | null | undefined;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_groupResults";
};
export type groupTableBody_nativeIssueTable_groupResults$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_groupResults">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_groupResults",
  "selections": [
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isDensityFull",
                  "variableName": "isDensityFull"
                },
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                },
                {
                  "kind": "Variable",
                  "name": "isTimelineEnabled",
                  "variableName": "isTimelineEnabled"
                },
                {
                  "kind": "Variable",
                  "name": "projectKey",
                  "variableName": "projectKey"
                },
                {
                  "kind": "Variable",
                  "name": "projectKeys",
                  "variableName": "projectKeys"
                }
              ],
              "kind": "FragmentSpread",
              "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "groupRow_issueTableGrouping_groupRow"
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "d74190b4f450b14e540d10c37f91944d";

export default node;
